import { IUser, User } from '../User';
import { IExpense } from './IExpense';

export class Expense {
  id: number;
  title: string;
  description: string;
  category: string;
  currency: string;
  amount: string;
  attachment: string;
  staff: User | null;
  dateOfTransaction: string;
  createdOn: string;
  updatedOn: string;

  constructor(Imodel: IExpense) {
    this.createdOn = Imodel.createdOn;
    this.amount = Imodel.amount;
    this.staff = Imodel.staff ? new User(Imodel.staff) : null;
    this.description = Imodel.description;
    this.category = Imodel.category;
    this.currency = Imodel.currency;
    this.createdOn = Imodel.createdOn;
    this.id = Imodel.id;
    this.title = Imodel.title;
    this.dateOfTransaction = Imodel.dateOfTransaction;
    this.attachment = Imodel.attachment;
    this.updatedOn = Imodel.updatedOn;
  }
}
